<template>
    <div>
        <v-navigation-drawer app
                             dark style="background-color:#656565"
                             persistent
                             :mini-variant="miniVariant"
                             :clipped="clipped"
                             v-model="drawer"
                             enable-resize-watcher
                             fixed>
            <v-list>
                <v-list-item to="/orgWorkSpace" exact>
                    <v-list-item-icon>
                        <v-icon>ub-home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="text-left">
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group v-if="dashboard.children"
                              :prepend-icon="dashboard.icon"
                              v-for="(dashboard, i) in dashboards"
                              :key="i">

                    <template v-slot:activator>
                        <v-list-item-content class="text-left">
                            <v-list-item-title v-text="dashboard.name" ></v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item v-for="(child, c) in dashboard.children"
                                 :key="c"
                                 style="padding-left: 40%"
                                 class="text-left"
                                 :to = "child.to" exact>
                        <v-list-item-title v-text="child.name"></v-list-item-title>
                        <v-list-item-icon>
                            <v-icon v-text="child.icon"></v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list-group>

                <v-list-item v-for="(dashboard, i) in dashboards" :key="i" :to="dashboard.to" v-if="!dashboard.children">
                    <v-list-item-icon>
                        <v-icon v-text="dashboard.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="text-left">
                        <v-list-item-title v-text="dashboard.name"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item >
                    <v-list-item-icon>
                        <v-icon>mdi-settings</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="text-left">
                        <v-list-item-title>Settings</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Application header -->
        <v-app-bar app
                style="background-color: #FFFFFF"
                :clipped-left="clipped">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer">
                <v-icon color="#4A87FF">
                ub-menu
                </v-icon>
            </v-app-bar-nav-icon>
            <v-btn icon class="hidden-md-and-down"
                   @click.stop="miniVariant = !miniVariant">
                <v-icon color="#4A87FF" v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
            </v-btn>
            <v-btn icon class="hidden-md-and-down"
                   @click.stop="clipped = !clipped">
                <v-icon color="#4A87FF">
                    ub-dashboard
                </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <label>
                    <b>UBehave</b> <span class="hidden-sm-and-down"> Helping to shape the future</span>
                </label>
            </v-toolbar-title>
            <v-layout align-center justify-end row warp>
                <v-btn icon>
                    <v-icon color="#4A87FF">
                        ub-notification
                    </v-icon>
                </v-btn>
                <logOut class="mr-2">Log Out</logOut>
            </v-layout>
        </v-app-bar>
        <!--Application content start here -->
        <v-container fluid pa-0 ma-0 style="background-color: white">
            <v-container fluid pb-0 mb-0 v-if="showAlerts">
                <v-alert v-for="(alert, i) in alerts"
                         :key="i"
                        v-model="alert.show"
                        dismissible
                        transition="scale-transition"
                        outlined
                        :type= "alert.type">
                    {{alert.msg}}
                </v-alert>
            </v-container>
            <router-view :key="$route.fullPath"></router-view>
        </v-container>
        <v-overlay :value="showLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!--footer -->
        <home-footer></home-footer>
    </div>
</template>

<script>
    const userDial = () => import( '@/components/common/UserDial');
    const logOut = () => import( '@/components/common/cognito/LogOut');
    import alertEventBus from '@/eventBus/AlertEventBus'
    const homeFooter = () => import( '@/components/appsView/homePage/HomeFooter');

    export default {
        name: "appContainer",
        components: {
            userDial, logOut, homeFooter
        },
        data() {
            return {
                clipped: false,
                drawer: true,
                fixed: false,
                miniVariant: false,
                right: true,
                rightDrawer: false,
                showAlerts: false,
                alerts:[],
                showLoading: false,
                dashboards: [
                    {
                        name: 'Employees', icon: 'ub-employees', children:[
                            {name: 'View', icon:'ub-employees', to: {name:'employeeTable'}},
                            {name: 'Category', icon: 'ub-employee', to: {name:'employeeTypeTable'}}
                        ]
                    },
                    {
                        name: 'Clients', icon: 'ub-clients', children:[
                            {name: 'View', icon:'ub-clients', to:{name:'clientTable'}},
                            {name: 'Category', icon: 'ub-client', to: {name:'clientTypeTable'}},
                            {name: 'Authorization', icon: 'fa-file-alt', to: {name:'clientAuthorizationTable'}},
                        ]
                    },
                    {
                        name: 'Documents', icon: 'fa-folder', children:[
                            {name: 'Category', icon: 'ub-document-group', to:{name:'documentGroupTable'}},
                            {name: 'Rules', icon: 'fa-file-alt', to:{name:'documentRuleTable'}}
                        ]
                    },
                    {
                        name: 'Reports', icon: 'fa-folder', children:[
                            {name: 'Category', icon: 'ub-document-group', to:{name:'reportGroupTable'}},
                            {name: 'Rules', icon: 'fa-file-alt', to:{name:'reportTable'}}
                        ]
                    },
                    {
                        name: 'Approvals', icon: 'fa-check-square', to:{name:'approval'}
                    },
                    {
                        name: 'Calendar', icon: 'ub-calendar', to:{name:'calendar'}
                    }

                ]
            }
        },
        methods: {
            setAlert(type, msg){
                this.showAlerts= true;
                let alert = {
                        type: type,
                        msg: msg
                    };
                this.alerts.push(alert);
            },
            clearAlert(){
                this.showAlerts= false;
                this.alerts = [];
            },
            setLoading(isLoading){
                this.showLoading = isLoading;
            }
        },
        created(){
            alertEventBus.$on('alert', (data) => {
               this.setAlert(data.type, data.msg) ;
            });
            alertEventBus.$on('clearAlert', () => {
                this.clearAlert() ;
            });
            alertEventBus.$on('setLoading', () => {
                this.setLoading(true) ;
            });
            alertEventBus.$on('clearLoading', () => {
                this.setLoading(false) ;
            });

        },
        beforeRouteUpdate (to, from, next) {
            this.clearAlert();
            next();
        }
    }
</script>

<!--Style for the entery orgWorkSpace here-->
<style scoped>
    .v-footer {
        padding: 10px;
    }

    #app{
        background-color: white !important;
    }
</style>